var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_848_906",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_848_906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 11.332C8.18954 11.332 8.34787 11.2681 8.47565 11.1404C8.60343 11.0126 8.66732 10.8543 8.66732 10.6654V7.9987C8.66732 7.80981 8.60343 7.65148 8.47565 7.5237C8.34787 7.39592 8.18954 7.33203 8.00065 7.33203C7.81176 7.33203 7.65343 7.39592 7.52565 7.5237C7.39787 7.65148 7.33398 7.80981 7.33398 7.9987V10.6654C7.33398 10.8543 7.39787 11.0126 7.52565 11.1404C7.65343 11.2681 7.81176 11.332 8.00065 11.332ZM8.00065 5.9987C8.18954 5.9987 8.34787 5.93481 8.47565 5.80703C8.60343 5.67925 8.66732 5.52092 8.66732 5.33203C8.66732 5.14314 8.60343 4.98481 8.47565 4.85703C8.34787 4.72925 8.18954 4.66536 8.00065 4.66536C7.81176 4.66536 7.65343 4.72925 7.52565 4.85703C7.39787 4.98481 7.33398 5.14314 7.33398 5.33203C7.33398 5.52092 7.39787 5.67925 7.52565 5.80703C7.65343 5.93481 7.81176 5.9987 8.00065 5.9987ZM8.00065 14.6654C7.07843 14.6654 6.21176 14.4904 5.40065 14.1404C4.58954 13.7904 3.88398 13.3154 3.28398 12.7154C2.68398 12.1154 2.20898 11.4098 1.85898 10.5987C1.50898 9.78759 1.33398 8.92092 1.33398 7.9987C1.33398 7.07648 1.50898 6.20981 1.85898 5.3987C2.20898 4.58759 2.68398 3.88203 3.28398 3.28203C3.88398 2.68203 4.58954 2.20703 5.40065 1.85703C6.21176 1.50703 7.07843 1.33203 8.00065 1.33203C8.92287 1.33203 9.78954 1.50703 10.6007 1.85703C11.4118 2.20703 12.1173 2.68203 12.7173 3.28203C13.3173 3.88203 13.7923 4.58759 14.1423 5.3987C14.4923 6.20981 14.6673 7.07648 14.6673 7.9987C14.6673 8.92092 14.4923 9.78759 14.1423 10.5987C13.7923 11.4098 13.3173 12.1154 12.7173 12.7154C12.1173 13.3154 11.4118 13.7904 10.6007 14.1404C9.78954 14.4904 8.92287 14.6654 8.00065 14.6654Z",
    fill: "#0078D4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfo);
export default __webpack_public_path__ + "static/media/ic_info.4ccb098bcfa130aaf02efe484704a823.svg";
export { ForwardRef as ReactComponent };